/** Arrow for risk-% change vs previous daily snapshot. */
export default function RiskTrendCell({ trend }) {
  const direction = trend?.direction || 'none';
  const delta = trend?.delta;

  if (direction === 'none') {
    return (
      <span className="inline-flex justify-end text-slate-300" title="Недостаточно замеров">
        —
      </span>
    );
  }

  if (direction === 'flat') {
    return (
      <span
        className="inline-flex items-center justify-end gap-0.5 tabular-nums text-slate-400"
        title="Без изменений"
      >
        <span aria-hidden="true">→</span>
        <span className="text-[10px]">0</span>
      </span>
    );
  }

  const worse = direction === 'up';
  const label = worse ? `Рост риска на ${delta} п.п.` : `Снижение риска на ${Math.abs(delta)} п.п.`;

  return (
    <span
      className={`inline-flex items-center justify-end gap-0.5 tabular-nums font-semibold ${
        worse ? 'text-rose-600 dark:text-rose-400' : 'text-emerald-600 dark:text-emerald-400'
      }`}
      title={label}
    >
      <span aria-hidden="true">{worse ? '↑' : '↓'}</span>
      <span className="text-[10px]">{Math.abs(delta)}</span>
    </span>
  );
}
